<template>
  <div>
    <v-navigation-drawer
      :value="value"
      @input="$emit('input', $event)"
      fixed
      temporary
      right
    >
      <v-list>
        <template v-if="$store.state.logged">
          <v-list-item class="d-flex justify-space-around align-center pb-2">
            <div class="d-flex text-body-1 font-weight-medium">
              {{ $store.state.user.name }}
            </div>
            <v-btn icon @click="$emit('input', false)">
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </v-list-item>
          <v-list-item class="d-flex justify-center">
            <v-card class="ma-0 pa-0" flat width="210px">
              <v-img src="@/assets/logo-eye.png" />
            </v-card>
          </v-list-item>
          <v-list-item>
            <v-row>
              <v-col cols="12" class="py-0 my-0 pt-3">
                <div class="text-subtitle-2">Localização:</div>
              </v-col>
              <v-col cols="12" class="py-0 ma-0">
                <div class="d-flex align-center">
                  <v-icon>mdi-map-marker</v-icon>
                  {{ user.city }} - {{ user.state }}
                </div>
              </v-col>
            </v-row>
          </v-list-item>
        </template>

        <template v-if="!$store.state.logged">
          <v-row>
            <v-col cols="9">
              <div class="text-h6 ml-3">Bem-vindo(a)!</div>
            </v-col>
            <v-col cols="3" class="">
              <v-btn icon @click.stop="$emit('input', false)">
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-list-item class="d-flex justify-center">
            <v-card class="ma-0 pa-0" flat width="210px">
              <v-img src="@/assets/logo-eye.png" />
            </v-card>
          </v-list-item>
          <v-list-item v-if="!$store.state.logged">
            <v-col cols="12" class="d-flex justify-center mb-0 pb-0">
              <v-btn color="#4B2A66" dark @click.stop="loginDialog = true"> Fazer Login </v-btn>
            </v-col>
          </v-list-item>
          <v-list-item v-if="$store.state.logged">
            <v-col cols="12" class="d-flex justify-center mb-0 pb-0">
              <v-btn color="#4B2A66" dark @click.stop="loginDialog = true"> Criar negócio </v-btn>
            </v-col>
          </v-list-item>
        </template>

        <v-divider class="white mt-3" />

        <v-list-item link exact :to="{name: 'home'}" color="#4B2A66">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Inicio</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link exact
          v-if="$store.state.logged"
          :to="{name: 'profile'}"
          color="#4B2A66"
        >
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Perfil</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group :value="false" no-action v-if="$store.state.logged" color="#4B2A66">
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-clipboard-multiple-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Negócios</v-list-item-title>
            </v-list-item-content>
          </template>

          <template v-for="shop in shops">
            <v-list-item
              :key="shop.id"
              link
              :to="{
                name: 'admin/home',
                params: { shop_url: shop.url },
              }"
            >
              <v-list-item-title>{{ shop.shop_name }}</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item link :to="{ name: 'register-shop' }">
            <v-list-item-title>Criar novo Negócio</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-item link exact :to="{ name: 'support' }" color="#4B2A66">
          <v-list-item-icon>
            <v-icon>mdi-help-box</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Suporte</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-if="$store.state.logged">
        <div class="pa-2">
          <v-btn
            color="#4B2A66"
            block
            @click="$store.commit('logout'), $emit('input', false)"
            :to="{ name: 'home' }"
          >
            Sair
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-dialog v-model="loginDialog" class="ma-0 pa-0" max-width="400px">
      <v-card>
        <Login @logged="loginDialog = false" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Login from "@/components/Login.vue";
export default {
  name: "Menu",
  props: {
    value: { required: true, type: Boolean },
  },
  components: { Login },
  data: () => ({
    loginDialog: false,
    shops: [],
  }),
  computed: {
    user(){
      return this.$store.state.user
    },
  },
  mounted() {
    this.$axios.get("/shop_user").then((response) => {
      this.shops = response.data;
    }).catch(() => {})
  },
};
</script>
